import React, { useEffect, useState } from 'react';
import { Button, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import auditDataStore from '../../stores/license/auditDataStore';
import { observer } from 'mobx-react';
import { LicenseReviewSubmitFormDTO } from '../../stores/models/licenseModels';

const SaveButton: React.FC = observer(() => {
    const [loading, setLoading] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error' | 'info'>('success');

    useEffect(() => {
        auditDataStore.formButtonColor = 'default';
    }, []);

    const handleSave = async () => {
        setLoading(true);

        // Check if every question has at least one selected option
        const incompleteActionsList = auditDataStore.currentFormState.licenseReviews.flatMap(review =>
            review.licenseReviewActions.filter(action => action.selectedOptions.length === 0).map(action => action.id)
        );

        if (incompleteActionsList.length > 0) {
            auditDataStore.setIncompleteActions(incompleteActionsList);
            setSnackbarMessage('Please select at least one option for every question.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            setLoading(false);
            return;
        }

        auditDataStore.setIncompleteActions([]);
        const data: LicenseReviewSubmitFormDTO = { licenseReviews: [], comment: '', LicenseFormId: '' };

        data.LicenseFormId = auditDataStore.currentFormState.id;
        data.comment = auditDataStore.currentFormState.comment;

        auditDataStore.currentFormState.licenseReviews.forEach(review => {
            review.licenseReviewActions.forEach(action => {
                if (action.selectedOptions && action.selectedOptions.length > 0) {
                    data.licenseReviews.push({
                        id: action.id,
                        selectedOptions: Array.isArray(action.selectedOptions) ? action.selectedOptions : [action.selectedOptions]
                    });
                }
            });
        });

        const result = await auditDataStore.saveLicenseForm(data);

        setSnackbarMessage(result.message);
        setSnackbarSeverity(result.severity as 'success' | 'error' | 'info');
        setSnackbarOpen(true);
        setLoading(false);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    if (auditDataStore.currentFormState.licenseReviews.length === 0) {
        return <></>;
    }

    return (
        <>
            <Button
                variant="contained"
                color="primary"
                onClick={handleSave}
                disabled={loading}
                className={auditDataStore.formButtonColor === 'success' ? 'license-form-save-button-success' : auditDataStore.formButtonColor === 'error' ? 'license-form-save-button-error' : ''}
            >
                Save
            </Button>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </>
    );
});

export default SaveButton;